var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C8A5C",
    fillRule: "evenodd",
    d: "M5.023 7.379 11.326.31a.93.93 0 0 1 1.387 0 1.123 1.123 0 0 1 0 1.5L5.78 9.576a1 1 0 0 1-.091.113.94.94 0 0 1-.698.311.93.93 0 0 1-.692-.31l-.045-.053L.287 5.053c-.383-.414-.383-1.329 0-1.743a.93.93 0 0 1 1.387 0z"
  })));
});
const SvgDoneIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoneIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEzIDEwIj4KICAgIDxwYXRoIGZpbGw9IiM0QzhBNUMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMDIzIDcuMzc5TDExLjMyNi4zMWEuOTMuOTMgMCAwIDEgMS4zODcgMCAxLjEyMyAxLjEyMyAwIDAgMSAwIDEuNUw1Ljc4IDkuNTc2YTEuMDUgMS4wNSAwIDAgMS0uMDkxLjExMy45NDMuOTQzIDAgMCAxLS42OTguMzExLjkyNy45MjcgMCAwIDEtLjY5Mi0uMzEgMS4wNDggMS4wNDggMCAwIDEtLjA0NS0uMDUzTC4yODcgNS4wNTNjLS4zODMtLjQxNC0uMzgzLTEuMzI5IDAtMS43NDNhLjkzLjkzIDAgMCAxIDEuMzg3IDBsMy4zNDkgNC4wNjl6Ii8+Cjwvc3ZnPgo=";